import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/landing/Header";
import Hero from "./components/landing/Hero";
import Features from "./components/landing/Features";
import Gallery from "./components/landing/Gallery";
import HowItWorks from "./components/landing/HowItWorks";
import Benefits from "./components/landing/Benefits";
import FAQ from "./components/landing/FAQ";
import LeadForm from "./components/landing/LeadForm";
import CTAFinal from "./components/landing/CTAFinal";
import Footer from "./components/landing/Footer";
import FloatingWhatsApp from "./components/landing/FloatingWhatsApp";
import { LanguageProvider } from "./i18n/LanguageContext";
import { LogoFilterDefs } from "./components/landing/Logo";
import { AuthProvider } from "./lib/AuthContext";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import VexlyOnePrivacy from "./pages/VexlyOnePrivacy";
import VexlyOneSupport from "./pages/VexlyOneSupport";
import VexlyOneDeleteAccount from "./pages/VexlyOneDeleteAccount";

const Landing = () => (
  <LanguageProvider>
    <div className="min-h-screen bg-[#0A0B0E] text-white antialiased">
      <LogoFilterDefs />
      <Header />
      <main>
        <Hero />
        <Features />
        <Gallery />
        <HowItWorks />
        <Benefits />
        <FAQ />
        <LeadForm />
        <CTAFinal />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  </LanguageProvider>
);

function App() {
  // Strip the auto-injected "Made with Emergent" badge whenever it appears.
  // The badge is injected at runtime by an external Emergent script outside
  // of our React tree, so we can't simply not-render it — we observe the DOM.
  useEffect(() => {
    const remove = () => {
      const el = document.getElementById("emergent-badge");
      if (el) el.remove();
    };
    remove();
    const obs = new MutationObserver(remove);
    obs.observe(document.body, { childList: true, subtree: false });
    const i = setInterval(remove, 1000);
    return () => {
      obs.disconnect();
      clearInterval(i);
    };
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/one/privacidad" element={<VexlyOnePrivacy />} />
          <Route path="/one/soporte" element={<VexlyOneSupport />} />
          <Route path="/one/eliminar-cuenta" element={<VexlyOneDeleteAccount />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
